enum ListingUploadStateEnum {
    NotStarted = 'Not Started',
    InProgress = 'In Progress',
    WaitingForReview = 'Waiting For Review',
    Published = 'Published',
}

export default ListingUploadStateEnum;
